if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
          this.scrollToTopOnCollapse(event);
        });
      }
      // Opt-in via data-scroll-to-top: after "Show less" the viewport can be
      // left far below a list that just shrank, so bring the group back on screen.
      scrollToTopOnCollapse(event) {
        if (!this.hasAttribute('data-scroll-to-top')) return;
        const isCollapsed = !this.querySelector('.label-show-more')?.classList.contains('hidden');
        if (!isCollapsed) return;
        event.target.closest('.parent-display')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        const parentWrap = parentDisplay.querySelector('.parent-wrap');
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}
